export const getFullName = (
	nombre?: string,
	apellido1?: string,
	apellido2?: string,
): string => {
	const nameArray = [nombre, apellido1, apellido2].filter(Boolean) as string[];
	const fullName = nameArray.reduce((acc, curr, i) => {
		if (i === 0) return `${acc}${curr}`;
		return `${acc} ${curr}`;
	}, '');
	return fullName;
};

export const parseJsonObj = <T>(json: string): T | undefined => {
	try {
		const data = JSON.parse(json);

		// Validación correcta: que sea objeto y no sea null
		if (typeof data !== 'object' || data === null) {
			throw new Error('El contenido del JSON no es un objeto');
		}

		return data as T;
	} catch (error) {
		console.error('Error al parsear el JSON:', error);
		return undefined;
	}
};
